import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Home/index.vue')
    },
    {
        path: '/news',
        name: 'News',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/News/index.vue')
    },
    {
        path: '/newslist',
        name: 'Newslist',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/News/newlist.vue')
    },
    {
        path: '/newscont',
        name: 'Newscont',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/News/newscont.vue')
    },
    {
        path: '/btc',
        name: 'btc',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/btc/index.vue')
    },
    {
        path: '/services',
        name: 'services',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/services/index.vue')
    },
    {
        path: '/markets',
        name: 'markets',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/markets/index.vue')
    },
    {
        path: '/regulation',
        name: 'regulation',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/regulation/index.vue')
    },
    {
        path: '/sso-callback',
        name: 'SSOCallback',
        component: () =>
            import ('../views/SSOCallback/index.vue')
    },
    {
        path: '/research',
        name: 'research',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/research/index.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/about/index.vue')
    },
    {
        path: '/nftmarket',
        name: 'nftmarket',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/nftmarket/index.vue')
    },
    {
        path: '/nftgallery',
        name: 'nftgallery',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/nftgallery/index.vue')
    },
    {
        path: '/nftcommodity',
        name: 'nftcommodity',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/nftgallery/commodity.vue')
    },
    {
        path: '/commodity',
        name: 'commodity',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/nftmarket/commodity.vue')
    },
]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        return {
            x: 0,
            y: 0
        }
    }
})

export default router